import { Component } from '@angular/core';

@Component({
  selector: 'app-session-logout',
  templateUrl: './session-logout.component.html',
  styleUrls: ['./session-logout.component.scss']
})
export class SessionLogoutComponent {}
